<template>
    <div class="filter-campaign-tree">
      <nestable-tree :value="value"
                     :options="campaigns"
                     :normalizer="normalizer"
                     :flat="true"
                     sort-value-by="LEVEL"
                     :no-options-text="$t('message.automation.message.noCampaignsRegistered')"
                     :placeholder="$t('message.automation.message.campaigns')"
                     @input="emitInput">
                     
                     
                     
        <div slot="option-label"
             slot-scope="{ node }">
          <filter-local-tree-item :noIcons="true" :node="node" />
        </div>
      </nestable-tree>
    </div>
  </template>
  
  <script>
  import FilterLocalTreeItem from "@/components/filters/local/tree/item/FilterLocalTreeItem";
  import NestableTree from "@/components/generic/nestable/tree/NestableTree";
  
  export default {
    components: {
      NestableTree,
      FilterLocalTreeItem,
    },
  
    data() {
      return {
        campaignsLoaded: false,
        // campaigns: [],
        normalizer(node) {
          return {
            id: node.id,
            label: node.name,
            children: node.interactions || node.options,
          };
        },
      };
    },

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        }
    },
  
    props: {
      value: {
        type: Array,
        default() {
          return [];
        },
      },
      step: {
        type: Object,
      },
      automationId: {
        type: String,
      },
      campaigns: {
        type: Array,
        default() {
          return [];
        }
      }
    },
  
    watch: {},  
  
    methods: {
      emitInput(val) {        
        this.$emit("input", val)
      },      
      emitSelect(val) {
        this.$emit("select", val);
      },
      emitDeselect(val) {
        this.$emit("deselect", val);
      },
      setNodes(node) {
        const newVal = [...this.value];
  
        const localIndex = newVal.findIndex((selectedNodeId) => {
          return selectedNodeId === node.localTreeId;
        });
  
        if (localIndex > -1) {
          newVal.splice(localIndex, 1);
        } else {
          newVal.push(node.localTreeId);
        }
  
        this.emitInput(newVal);
      },
      
      removeLastChildren(locals) {
        for (const local of locals) {
          if (local.children.length > 0) {
            this.removeLastChildren(local.children);
          } else {
            local.children = undefined;
          }
        }
  
        return locals;
      },
      
    },
  
    beforeDestroy() {},
  
    mixins: [],
  
    mounted() {},
  };
  </script>
  
  <style lang="scss" scoped>
    
  </style>
  